import React, { Fragment , useEffect } from "react";
import { Link } from "react-router-dom";
import Menu from "../components/menu.js";
import Navbar from "../components/navbar.js";
import Footer from "../components/footer.js";
function About(){
    useEffect(() => {
            document.title = "About | AA_Digitals"; // Change title
        }, []);
    return(
<Fragment>
<header className="header-one sticky-header">
<Menu></Menu>
<Navbar></Navbar>

    </header>
    
    <section className="breadcrumb-section bgc" style={{backgroundImage: "url(assets/img/bread2.jpg)"}}>
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-6">
                    <div className="breadcrumb-text">
                        <span className="title-tag">Welcome to our company</span>
                        <h2 className="page-title">About Us.</h2>
                    </div>
                </div>
                <div className="col-lg-7 col-md-6">
                    <div className="breadcrumb-nav">
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li className="separator">|</li>
                            <li>About</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section className="about-section section-gap">
        <div className="container">
            <div className="row align-items-center justify-content-center">
                <div className="col-xl-6 col-lg-9">
                    <div className="about-experience-galley mb-lg-gap-50">
                        
                        <div className="image-two" style={{backgroundImage: "url(assets/img/webabout1.webp)"}}>
                        </div>
                        <div className="experience-tag">
                            <span><span className="count">02</span>Years Experience</span>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-8 col-md-10">
                    <div className="about-text">
                        <div className="section-title mb-30">
                            <span className="title-tag">About Us</span>
                            <h2 className="title">
                                Get an amazing experience with quality level team
                            </h2>
                        </div>
                        <p>
                            Enjoy exceptional service from our highly skilled and dedicated team,
                             focused on delivering top-notch results with precision and excellence.
                              We are committed to surpassing your expectations through our extensive knowledge,
                               innovative strategies, and meticulous attention to detail. With a passion for perfection,
                                we ensure every aspect of your project is handled with accuracy and creativity,
                                 bringing your vision to life seamlessly. Count on us to enhance your project with
                                  a professional touch, delivering a smooth, efficient, and truly impressive outcome
                                   that stands out.
                        </p>
                        <Link to="/service" className="main-btn mt-30">Learn More</Link>
                       
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section className="service-area section-gap grey-bg">
        <div className="container">
            <div className="section-title text-center mb-30">
                <span className="title-tag">Services</span>
                <h2 className="title">Solutions we provide</h2>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6 col-sm-10">
                    <div className="service-box-two mt-30">
                        <span className="box-count">01</span>
                        <h4 className="title"><a href="#">Web Developemnt</a></h4>
                        <p>
                            Transforming ideas into dynamic web solutions with cutting-edge technologies and tailored strategies.
                        </p>
                       
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-10">
                    <div className="service-box-two mt-30">
                        <span className="box-count">02</span>
                        <h4 className="title"><a href="#">Graphical Designing</a></h4>
                        <p>Elevate your brand with captivating graphic design solutions that inspire and engage.
                        <div></div>
                        <div></div>
                        </p>
                           
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-10">
                    <div className="service-box-two mt-30">
                        <span className="box-count">03</span>
                        <h4 className="title"><a href="#">Logo Creation</a></h4>
                        <p>
                            We design distinctive logos that capture your essence and leave a lasting impression. 

                            <div></div>
                            <div></div>
                        </p>
                       
                    </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-10">
                    <div className="service-box-two mt-30">
                        <span className="box-count">04</span>
                        <h4 className="title"><a href="#">Poster Designing</a></h4>
                        <p>
                            Discover the art of captivating communication with us' bespoke poster designs. From concept to creation, we craft visuals that resonate and inspire.
                        </p>
                        
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-10">
                    <div className="service-box-two mt-30">
                        <span className="box-count">05</span>
                        <h4 className="title"><a href="#">SEO</a></h4>
                        <p>
                            "We optimize websites to rank higher, ensuring your business reaches its target audience effectively."
                            <div></div>
                            <div></div>
                        </p>
                        
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-10">
                    <div className="service-box-two mt-30">
                        <span className="box-count">06</span>
                        <h4 className="title"><a href="#">Photography</a></h4>
                        <p>
                            "Capture moments, create memories.Our photography brings your vision to life with creativity and precision, ensuring every shot tells a compelling story."
                        </p>
                        
                    </div>
                </div>

            </div>
        </div>
    </section>
    
    <section className="testimonial-section with-pattern testimonial-brand-section primary-bg" id="feedbacks">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    <div className="section-title text-center mb-50">
                        <span className="title-tag">Testimonials</span>
                        <h2 className="title">Clients <span>feedbacks</span></h2>
                    </div>
                    <div className="testimonial-slider-progress mb-40">
                        <span className="line-one"></span>
                        <span className="line-two"></span>
                    </div>
                </div>
            </div>
            <div className="testimonial-boxes row" id="testimonialSliderOne">
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt1.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”Aa_digitals built us a website that not only reflects our brand perfectly,  Their expertise in web design and optimization is unparalleled.”
                            </p>
                            <div className="author-info">
                                <h5>Agnes jeniffer</h5>
                                <span>business owner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt2.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”Choosing Aa_digitals was the best decision we made for our online growth. Their expertise and dedication are unmatched in the industry.”
                            </p>
                            <div className="author-info">
                                <h5>Maddya Begum</h5>
                                <span>Social meadia manager</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt3.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”Aa_digitals transformed our online presence with a stunning, user-friendly website that perfectly captures our brand essence.”
                            </p>
                            <div className="author-info">
                                <h5>Jacob</h5>
                                <span>business</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt4.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”Aa_digitals exceeded our expectations with a website that not only showcases our brand beautifully but also drives measurable results.”
                            </p>
                            <div className="author-info">
                                <h5>Merwin mathew</h5>
                                <span>business</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </section>
   
    <Footer></Footer>
</Fragment>
    )
}
export default About;